import Api from './Api'

export default {
    get(keyword, pageNumber, pageSize, order) {
        return Api().get(`centro_dialise/estado?keyword=${keyword}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderColumn=${order.column}&orderSort=${order.sort}`);
    },
    getOne(id) {
        return Api().get(`centro_dialise/${id}`);
    },
    getTotalByState() {
        return Api().get(`centro_dialise/centrosPorEstado`);
    },
    getByState(uf, keyword = '', pageNumber = 1, pageSize = 12) {
        const url = uf ? `centro_dialise/estado/${uf}` : 'centro_dialise/estado';
        return Api().get(`${url}?keyword=${keyword}&pageNumber=${pageNumber}&pageSize=${pageSize}`);
    },
    getByCity(cidade, keyword = '', pageNumber = 1, pageSize = 12) {
        return Api().get(`centro_dialise/cidade/${cidade}?keyword=${keyword}&pageNumber=${pageNumber}&pageSize=${pageSize}`);
    },
}